// extracted by mini-css-extract-plugin
export default {"container":"nobelCauseComponent_container__Dk+34","header":"nobelCauseComponent_header__2K2eK","para":"nobelCauseComponent_para__Z+bcR","image":"nobelCauseComponent_image__wiiIf"};